<template>
    <v-app>
        
        <v-main>
            <v-btn
                absolute
                top
                right
                text
                color="primary"
                outlined
                @click="closeApplication"
                class="d-none d-md-flex"
            >
                Close Application
            </v-btn>
            <v-fab-transition>
                
                <v-btn
                    fab
                    color="primary"
                    dark
                    absolute
                    top
                    right
                    small
                    class="d-flex d-sm-none"
                    style="z-index:3; position:fixed"
                    @click="closeApplication"
                >
                    <v-icon
                        small
                    >mdi-close</v-icon>
                </v-btn>
            </v-fab-transition>   

            <!-- Form Header -->
            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="700"
                        flat
                    >  
                        
                        <v-img
                            :src="require('../assets/logo.png')"
                            contain
                            height="70"
                        />
                        <h1 class="primary--text  font-weight-bold">
                            {{ schoolName }}
                        </h1>
                        
                        <div class="mt-4 primary--text font-weight-bold text-h5">
                            FORM 3 - CHOICE OF SUBJECTS FORM
                        </div>
                        
                    </v-card>
                    
                </v-col>
            </v-row>

            <v-row class="">
                <v-col
                    align="center"
                    justify="center"
                >
                   
                    <v-card            
                        width="550"
                        class="mt-10"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            STUDENT INFORMATION
                        </v-card-title>
                        
                    </v-card>
                </v-col>
            </v-row>

            <v-row
                align="center"
                justify="center"
            >
                <v-card
                    class="pa-6 mt-5" 
                    width="550"
                >
                    <v-row 
                        align="center"
                        justify="center"
                        v-for="(field, index) in fields"
                        :key="index"
                    >
                        <v-col
                            cols="12"                       
                        >
                            <date-picker
                                v-if="field.type == 'date'"
                                v-bind:label="field.label"
                                v-bind:date="recordApplication[field.model]"
                                v-on:change-date="updateDate"
                                v-bind:saveStatus="field.saveStatus"
                            ></date-picker>

                            <!-- Phone field -->
                            <v-text-field
                                v-else-if="field.type == 'phone'"
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @keypress="numberOnly"
                                :prepend-icon="field.icon"
                                placeholder=" "
                                hint="Enter 7 digits only"
                                persistent-hint
                                prefix="1868"
                                maxlength="7"
                                autocomplete="none"
                                :ref='field.ref'
                                :rules="[() => validatePhone(recordApplication[field.model])]" 
                                @change="updateApplication"
                                hide-details="auto"                                                 
                            >
                                 <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>

                            <v-text-field
                                v-else
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @blur="validate(field, 'application')"
                                :prepend-icon="field.icon"                            
                                autocomplete="none"
                                :counter="field.counter"
                                :maxlength="field.maxlength" 
                                :disabled="field.disabled"
                                :filled="field.filled"
                                :ref="field.ref"
                                :rules="[() => recordApplication[field.model] ? true : 'This field is required']"    
                                hide-details="auto"    
                            >
                                <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>     
                </v-card>
            </v-row>

            <!-- Choice of Subjects -->
            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            <div>CHOICE OF CSEC SUBJECTS</div> 
                            
                        </v-card-title>

                        <v-card-text>
                            <v-alert
                                border="left"
                                colored-border
                                type="info"
                                class="mt-4 text-justify"
                                color="primary"
                                text
                                outlined
                            >
                                Choose <strong>ONE</strong> subject from <strong>EACH GROUP</strong> listed as your <strong>first choice</strong>.
                                Then a <strong>second</strong> and <strong>third choice</strong> in the event you are <strong> not granted</strong> the first choice.
                            </v-alert>

                        </v-card-text>

                        <v-card-text>
                            
                            <div v-for="(group, key) in groups" :key="key" class="mb-4">
                                <v-alert
                                    text
                                    color="primary"
                                    dense
                                    border="left"
                                    colored-border
                                >
                                    Group {{ key}}
                                </v-alert>

                                <v-data-table
                                    :headers="headersSubjectChoice"
                                    :items="group"
                                    hide-default-footer
                                    hide-default-header
                                >
                                    <template v-slot:item="{ item }">
                                        <tr>
                                            <td>
                                                {{ item.choiceTitle }} Choice
                                            </td>
                                            <td class="py-3">
                                                <v-select
                                                    outlined
                                                    dense
                                                    placeholder="Subject"
                                                    :items="item.subjects"
                                                    item-text="title"
                                                    item-value="subject_id"
                                                    v-model="subjectChoices[item.choice][key]"
                                                    @change="updateSubjectChoice(item.choice, key)"
                                                    hide-details="auto"    
                                                    :ref="`${item.choice}-${key}`"
                                                    :rules="[value => value ? true : 'This field is required']" 
                                                    :error-messages="getError(item.choice, key)"
                                                >
                                                    <template v-slot:append-outer>
                                                        <v-fade-transition>
                                                            <v-progress-circular
                                                                v-if="item.saveStatus.saving"
                                                                size="16"
                                                                width="3"
                                                                color="info"
                                                                indeterminate
                                                            ></v-progress-circular>
                                                        </v-fade-transition>
    
                                                        <v-fade-transition>    
                                                            <v-icon
                                                                v-if="item.saveStatus.saveSuccess"
                                                                small
                                                                color="info"                                        
                                                            >
                                                                mdi-check-all
                                                            </v-icon>
                                                        </v-fade-transition>
    
                                                        <v-fade-transition>    
                                                            <v-icon
                                                                v-if="item.saveStatus.saveError"
                                                                small
                                                                color="red"                                        
                                                            >
                                                                mdi-alert-circle
                                                            </v-icon>
                                                        </v-fade-transition>
                                                    </template>
                                                </v-select>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </div>

                        </v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>

            <!-- Generate Choice of Subjects Form -->
            <v-row class="mt-4">
                 <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-btn
                            block
                            color="primary"
                            @click="displayApplicationForm"
                        >
                            Generate Choice of Subjects Form
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>  

            <v-row class="mt-4">
                 <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-btn
                            block
                            color="primary"
                            @click="submitApplication"
                        >
                            Submit Application
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>       
        </v-main>

        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>

        // Report Dialog
        <v-dialog
            v-model="dialogReport"                      
            persistent
        >
           <v-card height="80vh">
            <iframe ref="pdf" style="width:100%; height:100%" frameBorder="0" :src="src"></iframe>
           </v-card>

            <v-container
                fluid
                class="pa-0"
            >
                <v-sheet>
                    <v-row
                        justify="end"
                        class="ma-0"
                    >

                        <v-btn
                            color="primary"
                            dark
                            @click="closeRegistrationForm"
                            class="my-2 mr-4"
                        >
                            Close
                        </v-btn>

                    </v-row>
                </v-sheet>
            </v-container>

        </v-dialog>

        <v-dialog v-model="dialogSubmit" width="500" persistent>
            <v-card class="pt-6" outlined>
                <v-card-text v-if="submitError" class="mt-4">
                    <v-alert
                        border="left"
                        colored-border
                        type="error"
                        class="mt-4 text-justify"
                        color="red"
                        text
                        outlined
                    >
                        Please fill in all missing Fields and ensure all fields are valid before submitting your application.
                    </v-alert>
                </v-card-text>
                <success v-else></success>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        dark
                        @click="dialogSubmit = false;"
                        class="mr-2"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogError" width="500" persistent>
            <v-card class="pt-6" outlined>
                <v-card-text>
                    <v-alert
                        border="left"
                        colored-border
                        type="error"
                        class="mt-4 text-justify"
                        color="red"
                        text
                        outlined
                    >
                        Unable to add your choice. Please ensure there is no duplicate subjects and try again.
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        dark
                        @click="dialogError = false;"
                        class="mr-2"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import DatePicker from '../components/DatePicker.vue';
import Success from '../components/Success.vue';
export default {
    created: function () {
        
        this.initialize();
    },

    components: {
        DatePicker,
        Success,
    },

    data: function () {
        return {
            fields: [
                {
                    label: 'First Name', 
                    model: 'first_name', 
                    type: 'text', 
                    disabled: true,
                    filled: true,
                    required: false,
                    ref: 'firstName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Last Name', 
                    model: 'last_name', 
                    type: 'text', 
                    disabled: true,
                    filled: true,
                    required: false,
                    ref: 'lastName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },                    
                    record: 'application',
                },
                
                {
                    label: 'Birth Certificate Pin', 
                    model: 'birth_certificate_pin', 
                    type: 'text', 
                    disabled: true,
                    filled: true,
                    required: false,
                    ref: 'birthCertificatePin',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                
                {
                    label: 'Career Goal 1', 
                    model: 'career_goal_1', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'careerGoal1',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Career Goal 2', 
                    model: 'career_goal_2', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'careerGoal2',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Parent/Guardian First Name', 
                    model: 'parent_first_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'parentFirstName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Parent/Guardian Last Name', 
                    model: 'parent_last_name', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'parentLastName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Parent/Guardian Phone Number', 
                    model: 'parent_contact_mobile',
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'parentContactMobile',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Student Phone Number', 
                    model: 'student_contact_mobile',
                    type: 'phone', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'studentContactMobile',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
               
            ],
            recordApplication: {},
            headersSubjectChoice: [
                {text: ''},               
                {text: ''},               
            ],
            groups:{
                1: [],
                2: [],
                3: [],
                4: [],
                5: [],
            },
            subjectChoices: {
                    1: {},
                    2: {},
                    3: {},
            },
            overlay: false,
            src: '',
            dialogReport: false,
            subjects: {},
            dialogSubmit: false,
            submitError: false,
            errors: {},
            dialogError: false,
        }
    },

    computed: {
        ...mapGetters({
            application: 'application/getApplication',
            applicationGrade: 'application/getApplicationGrade',
            schoolName: 'auth/getSchoolName', 
            user: 'auth/getUser',
        }),

        regex(){
            return new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) 
        },
        
    },

    methods: {

        ...mapMutations({
            setApplication: 'application/setApplication',
            setApplicationSubjectChoice: 'application/setApplicationSubjectChoice',
            setApplicationGrade: 'application/setApplicationGrade',
            setApplicationYear: 'application/setApplicationYear',
        }),

        ...mapActions({
            postApplication: 'application/postApplication',
            postApplicationSubjectChoice: 'application/postApplicationSubjectChoice',
            getSubjectLines: 'application/getSubjectLines',
            getApplicationSubjectChoices: 'application/getApplicationSubjectChoices',
            getApplicationsLockStatus: 'application/getApplicationsLockStatus',
            getCurrentApplicationPeriod: 'application/getCurrentApplicationPeriod',
            getApplication: 'application/getApplication',
        }),

        async initialize () {
            this.overlay = true;
            const user = JSON.parse(this.user);
            try {
                const { data } = await this.getApplication(user.id);

                this.recordApplication = {
                    first_name: data.first_name,
                    last_name: data.last_name,
                    birth_certificate_pin: data.birth_certificate_pin,
                    career_goal_1: data.career_goal_1,
                    career_goal_2: data.career_goal_2,
                    parent_contact_mobile: data.parent_contact_mobile,
                    student_contact_mobile: data.student_contact_mobile,
                    parent_first_name: data.parent_first_name,
                    parent_last_name: data.parent_last_name,
                    student_id: user.id,
                }
                
                this.setApplication(this.recordApplication);

                
                const[
                    { data: dataSubjectLines},
                    { data: dataSubjectChoices },
                ] = await Promise.all([
                    this.getSubjectLines(),
                    this.getApplicationSubjectChoices()
                ])
                this.mapSubjectLines(dataSubjectLines);
                this.mapSubjectChoices(dataSubjectChoices);
                
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            this.overlay = false;
        },

        mapSubjectLines (data) {
            let choices = ['1st', '2nd', '3rd'];

            Object.keys(this.groups).forEach(key => {
                for(let i = 1; i <= 3; i++){
                    this.groups[key].push({
                        choiceTitle: choices[i-1],
                        choice: i,
                        subjects: data.filter(subject => subject.group == key).map(subject => ({...subject})),
                        saveStatus: {
                            saving: false,
                            saveSuccess: false,
                            saveError: false,
                        },
                    }) 
                }
                this.subjects[key] = data.filter(subject => subject.group == key).map(subject => ({...subject}));
            })
        },

        mapSubjectChoices (data) {
            Object.keys(this.groups).forEach(key => {
                this.groups[key].forEach(item => {
                    this.subjectChoices[item.choice][key] = null;
                    if(data.filter(choice => choice.choice == item.choice && choice.group == key).length > 0) this.subjectChoices[item.choice][key] = data.filter(choice => choice.choice == item.choice && choice.group == key)[0].subject_id;
                })
            })
        },

        validate (field) {
            // console.log(field)
            if(this.recordApplication[field.model]){
                this.updateApplication(field)
            }
        },

        async updateApplication (field) {
            this.setSaveStatus(field);
            try {
                this.setApplication(this.recordApplication);
                console.log('applicaiton: ', this.recordApplication);
                const response = await this.postApplication();
                console.log(response);
                this.setSaveStatus(field, 'saveSuccess');
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                
                this.setSaveStatus(field, 'saveError');  
            }
        },

        async updateSubjectChoice (choice, group) {
            if(this.subjectChoices[choice][group]) this.validateSubjecChoice();
            this.setApplicationSubjectChoice({
                choice: choice,
                group: group,
                subject_id: this.subjectChoices[choice][group],
                student_id: this.recordApplication.student_id,
            });
            this.setSaveStatusSubjectChoice(choice, group);
            try {
                await this.postApplicationSubjectChoice();
                this.setSaveStatusSubjectChoice(choice, group, 'saveSuccess');
                this.filterChoices(choice, group);
                //this.validateApplication();
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.dialogError = true;
                this.setSaveStatusSubjectChoice(choice, group, 'saveError');
            }
        },

        filterChoices (choice, group){
            const subjectIds = Object.values(this.subjectChoices).map(choice => choice[group]).filter(Boolean);
            console.log('subjectIds: ', subjectIds);
            this.groups[group].forEach(item => {
                if(item.choice != choice){
                    item.subjects = this.subjects[group].filter(subject => !subjectIds.includes(subject.subject_id) );
                    if(this.subjectChoices[item.choice][group]){
                        item.subjects.push(this.subjects[group].filter(subject => subject.subject_id == this.subjectChoices[item.choice][group])[0]);
                    }
                }
            })
        },

        mapApplicationLock ({ locked }) {
            console.log(locked);
            if(locked){
                this.fields.forEach(f => {
                    f.disabled = true;
                });
                this.subjects.forEach(s => {
                    s.disabled = true;
                });
                this.group1.forEach(c => {
                    c.disabled = true;
                })
                this.group2.forEach(c => {
                    c.disabled = true;
                })
                this.documents.forEach(d => {
                    d.disabled = true;
                })
            }
        },

        updateDate (date) {
            console.log(date);
            this.recordApplication.date_of_birth = date;
            let dateOfBirthField = this.fields.filter(field => field.model == 'date_of_birth')[0]
            this.update('application', dateOfBirthField);
        },


        setSaveStatus (field, status = 'saving') {
            this.fields.forEach(value => {
                if(value.model == field.model){
                    Object.keys(field.saveStatus).forEach(key => {
                        if(key == status) field.saveStatus[key] = true;
                        else field.saveStatus[key] = false;
                    })
                }
            })
        },

        setSaveStatusSubjectChoice (choice, group, status = 'saving') {
            this.groups[group].forEach(item => {
                if(item.choice == choice){
                    Object.keys(item.saveStatus).forEach(key => {
                        if(key == status) item.saveStatus[key] = true;
                        else item.saveStatus[key] = false;
                    })
                }
            })
        },

        displayApplicationForm () {
            this.src = `${process.env.VUE_APP_API_URI}/api/csec-subject-selection-form?student_id=${this.recordApplication.student_id}"`; 
            this.dialogReport = true;
        },

        closeRegistrationForm () {
            console.log('close registration form');
            this.dialogReport = false;
            this.overlay = false;
            this.src = '';
        },

        closeApplication () {
            sessionStorage.clear();
            this.$router.replace('/');
        },

        submitApplication () {
            this.submitError = true;
            if(this.validateApplication()){
                console.log('application: ', this.application)
                this.submitError = false;
            } 
            this.dialogSubmit = true;
        },

        validateApplication () {
            let valid = true;
            Object.entries(this.recordApplication).forEach(([key, value]) => {
                if(!value) {
                    let field = this.fields.filter(f => f.model == key)[0];
                    if(field) this.$refs[field.ref][0].validate();
                    valid = false;
                }
            })
            
            Object.entries(this.subjectChoices).forEach(([choice, groups]) => {
                Object.entries(groups).forEach(([group, subjectId]) => {
                    const key = `${choice}-${group}`;
                    if(!subjectId){
                        valid = false;
                        this.$set(this.errors, key, ['This field is required']);
                    }else{
                        this.$set(this.errors, key, [])
                    }
                })
            })
            return valid;
        },

        validateSubjecChoice (){
             Object.entries(this.subjectChoices).forEach(([choice, groups]) => {
                Object.entries(groups).forEach(([group, subjectId]) => {
                    const key = `${choice}-${group}`;
                    if(!subjectId){
                        this.$set(this.errors, key, ['This field is required']);
                    }else{
                        this.$set(this.errors, key, [])
                    }
                })
            })
        },

        numberOnly($event){            
            if(!/\d/.test($event.key)) return $event.preventDefault();
        },

        validatePhone (value){
            if(value && String(value).length == 7) return true;
            else return '7 Digits Needed';
        },

        getError(choice, key){
            return this.errors[`${choice}-${key}`] || [];
        }
    }
   
}
</script>

<style scoped>
    ::v-deep .theme--light.v-btn.v-btn--outlined.v-btn--text{
        position: fixed;
        z-index: 2;
    }

    ::v-deep .v-btn--fab.v-size--small.v-btn--absolute.v-btn--top {
        top: 25px;
    }
</style>
